<template>
  <div class="page-container">
    <!-- 标题 -->
    <div class="header">
      <!-- people -->
      <div class="person">
        <img class="person-img" src="../../assets/img/user/touxiang.png" alt="altText" />
        <div class="person-name">
          <div class="person-all">
            <div class="d1">{{ userInfo.custName }}</div>
            <div class="memberGrade" v-if="userInfo.openMember" @click="clickMemberCenter">
              <img class="memberGrade-img" :src="userInfo.logo" fit="cover" alt="会员等级" />
            </div>
          </div>
          <div class="d2">
            <span> ID:{{ userInfo.custAccount.custId }}</span>
            <span @click="personalClick">&nbsp;&nbsp;个人中心</span>
            <van-icon name="arrow" @click="personalClick" />
          </div>
        </div>
      </div>
      <!-- setting -->
      <div class="setting" @click="settingClick">
        <van-icon size="20px" name="setting-o" />
      </div>
    </div>

    <div class="content">
      <!-- 会员权益 -->
      <div class="memberCenter" v-if="userInfo.openMember" @click="clickMemberCenter">
        <div class="member-left">
          <div class="member-zq">会员专区</div>
          <div class="member-server">
            <span class="member-server1">专享服务</span>
            <span class="member-server2">会员特权</span>
          </div>
        </div>
        <div class="member-right">
          <div class="right-bg">
            <span class="member-qy">查看权益</span>
          </div>
        </div>
      </div>
      <!-- 我的投资报告 -->
      <div class="reportCenter" v-if="userInfo.isShowExport == 1" @click="clickReportCenter">
        <div class="bottom-bg">
          <div class="title">我的投资报告</div>
          <img src="../../assets/img/my-redpack/anniversary/anniversary_look_btn.png" />
        </div>
      </div>
      <!-- 资产 -->
      <div class="assets-bg">
        <div class="assets">
          <div class="all">
            <div class="d1">
              <span style="font-weight: 700;color: #333;">总资产(元)</span>
              <van-icon name="eye-o" size="18" @click="off" v-show="onShow" />
              <van-icon name="closed-eye" size="18" @click="on" v-show="offShow" />
            </div>
            <div class="d2">
              {{
                eysMoney(
                  numFormat(
                    this.userInfo.custAccount.assetsAll +
                    getSpecialProductTotalBalance
                  )
                )
              }}
              <van-icon v-if="
                userInfo.custAccount.productExAmount &&
                userInfo.custAccount.productExAmount > 0
              " class="question-bg" style="margin-left: 5px" name="question" size="16" color="rgb(142, 144, 146)"
                @click.stop="showProductExAmountTips = true" />
            </div>
          </div>
          <div class="Obtain">
            <div class="d1">
              <span class="sp1">预期收益(元)：</span>
              <span class="sp2">{{
                eysMoney(numFormat(userInfo.custAccount.expectAmount + userInfo.pydWillIncome))
                }}</span>
            </div>
            <div class="d2"></div>
            <div class="d3">
              <span class="sp1">累计收益(元)：</span>
              <span class="sp2">{{
                eysMoney(numFormat(userInfo.custAccount.totalBeenAmount + userInfo.pydReadyIncome))
                }}</span>
            </div>
          </div>
        </div>
        <hr class="underline" />
        <div class="assets" style="padding-top: 10px;">
          <div class="all">
            <div class="d1" style="font-weight: 700;color: #333;">
              <span>委托竞拍资产</span>
            </div>
          </div>
          <div class="Obtain">
            <div class="d1">
              <span class="sp1">预期收益(元)：</span>
              <span class="sp2">{{
                eysMoney(numFormat(userInfo.custAccount.expectAmount))
                }}</span>
              <van-icon v-if="
                userInfo.custAccount.productExReturnAmount &&
                userInfo.custAccount.productExReturnAmount > 0
              " class="question-bg" style="margin-left: 5px" name="question" size="16" color="rgb(142, 144, 146)"
                @click.stop="showProductExReturnAmountTips = true" />
            </div>
            <div class="d2"></div>
            <div class="d3">
              <span class="sp1">累计收益(元)：</span>
              <span class="sp2">{{
                eysMoney(numFormat(userInfo.custAccount.totalBeenAmount))
                }}</span>
            </div>
          </div>
          <div class="Obtain">
            <div class="d1">
              <span class="sp1">预期待收金额(元)：</span>
              <span class="sp2">{{
                eysMoney(numFormat(userInfo.custAccount.assetsHeld))
              }}</span>
            </div>
          </div>
          <div class="Obtain">
            <div class="d1">
              <span class="sp1">申请中(元)：</span>
              <span class="sp2">{{
                eysMoney(numFormat(userInfo.custAccount.assetsApplying))
                }}</span>
            </div>
            <div class="d2"></div>
            <div class="d3" @click="goWithdrawClick">
              <span class="sp1">提现中(元)：</span>
              <span class="sp2">{{
                eysMoney(numFormat(userInfo.custAccount.assetsWithdrawing))
                }}</span>
              <van-icon name="arrow" />
            </div>
          </div>
          <div class="experience" v-if="userInfo.custAccount.showExperience">
            <span class="sp1">体验金收益(元)：</span>
            <span class="sp2">{{
              eysMoney(numFormat(userInfo.custAccount.experienceAmount || 0))
              }}</span>
            <van-icon class="question-bg" style="margin-left: 5px" name="question" size="16" color="rgb(142, 144, 146)"
              @click.stop="showExperienceTips = true" />
          </div>
          <div class="Obtain">
            <van-cell class="menu" :to="{ name: 'tradingRecord' }" is-link>
              <template #title>
                <div>
                  <span class="balance-title">可用余额(元)：</span>
                  <span class="balance-value">{{
                    eysMoney(
                      numFormat(
                        userInfo.custAccount.balance +
                        getSpecialProductTotalBalance
                      )
                    )
                  }}</span>
                  <van-icon v-if="balances.length > 0" class="question-bg" style="margin-left: 5px" name="question"
                    size="16" color="rgb(142, 144, 146)" @click.stop="showBalanceAvailabelQuestion = true" />
                </div>
              </template>
            </van-cell>
          </div>
        </div>
        <hr class="underline" />
        <div class="assets" style="padding-top: 10px;">
          <div class="all">
            <div class="d1" style="font-weight: 700;color: #333;">
              <span>竞拍资产</span>
            </div>
          </div>
          <div class="Obtain">
            <div class="d1">
              <span class="sp1">预期收益(元)：</span>
              <span class="sp2">{{
                eysMoney(numFormat(userInfo.pydWillIncome || 0))
                }}</span>
            </div>
            <div class="d2"></div>
            <div class="d3">
              <span class="sp1">累计收益(元)：</span>
              <span class="sp2">{{
                eysMoney(numFormat(userInfo.pydReadyIncome || 0))
                }}</span>
            </div>
          </div>
          <div class="Obtain">
            <div class="d1">
              <span class="sp1">预期待收金额(元)：</span>
              <span class="sp2">{{
                eysMoney(numFormat(userInfo.pydWillAmount || 0))
                }}</span>
            </div>
          </div>
          <div class="Obtain">
            <div class="d1">
              <span class="sp1">可用余额(元)：</span>
              <span class="sp2">{{
                eysMoney(numFormat(userInfo.custAccount.pydBalance || 0))
                }}</span>
            </div>
          </div>
        </div>
        <hr class="underline" />
        <div class="balance-list">
          <!-- 体现/充值按钮 -->
          <div class="chongzhi-bg">
            <div class="chongzhi">
              <van-button class="b1" plain @click="onWithdrawDeposit">提现</van-button>
              <!-- <van-button class="b2" plain @click="onRecharge">充值</van-button> -->
            </div>
          </div>
        </div>
      </div>
      <!-- 商城/理财/拍卖/订单 -->
      <div class="center-bg">
        <ul class="center-list">
          <li class="item" :style="{
            width:
              centerList.length > 3 ? '25%' : 100 / +centerList.length + '%'
          }" v-for="(item, index) in centerList" :key="index" @click="onCenterItem(item)">
            <img :class="item.id == '111' ? 'shuang11-img' : 'item-img'" :src="item.imgPath" :alt="item.title"
              fit="cover" />
            <div class="item-title">{{ item.title }}</div>
          </li>
        </ul>
      </div>
      <!-- 我的 -->
      <div class="my">
        <div class="my-list">
          <van-cell class="menu trade-record" :class="['menu', getActiveClass(bankcard.count !== '')]" title="我的银行卡"
            :value="bankcard.count" @click="toCardList" is-link>
            <div slot="icon" class="menu-icon">
              <img src="../../assets/img/user/icon4.png" alt />
            </div>
          </van-cell>
          <!-- "400-694-0070" -->
          <van-cell class="menu" title="客服电话" value="400-694-0070" url="tel:400-694-0070">
            <div slot="icon" class="menu-icon">
              <img src="../../assets/img/user/kefu.png" alt="" />
            </div>
          </van-cell>
          <van-cell v-if="
            channel &&
            ['ta'].includes(channel.toLowerCase()) &&
            (!userInfo.orgReferrerUserId ||
              userInfo.orgReferrerUserId.length == 0)
          " class="menu" title="客服专员" value="" is-link @click="onPreview">
            <div slot="icon" class="menu-icon">
              <img src="../../assets/img/user/kefu.png" alt="" />
            </div>
          </van-cell>
          <van-cell class="menu trade-record" title="我的邀请" is-link @click="toMyInvite">
            <div slot="icon" class="menu-icon">
              <img src="../../assets/img/user/invite.png" alt="" />
            </div>
          </van-cell>
          <template v-if="
            channel &&
            ['ta'].includes(channel.toLowerCase()) &&
            (!userInfo.orgReferrerUserId ||
              userInfo.orgReferrerUserId.length == 0)
          ">
            <van-cell class="menu" :to="{ name: 'coupon-list' }" title="我的福利券" :value="couponCount + '张'" is-link>
              <div slot="icon" class="menu-icon">
                <img src="../../assets/img/user/icon5.png" alt />
              </div>
            </van-cell>
          </template>
          <template v-else>
            <van-cell class="menu" :to="{ name: 'coupon' }" title="我的优惠券" :value="couponCount + '张'" is-link>
              <div slot="icon" class="menu-icon">
                <img src="../../assets/img/user/icon5.png" alt />
              </div>
            </van-cell>
          </template>
          <van-cell class="menu" v-if="
            channel &&
            ['bl', 'zn', 'tajk', 'ht', 'nyt'].includes(channel.toLowerCase())
          " :to="{ name: 'pointsmall' }" title="我的积分" is-link>
            <div slot="icon" class="menu-icon">
              <img src="../../assets/img/user/icon7.png" alt />
            </div>
            <span>{{ userInfo.custAccount.score }}积分</span>
          </van-cell>
          <van-cell class="menu" v-if="
            channel &&
            ['bl', 'zn', 'tajk', 'ht', 'nyt'].includes(channel.toLowerCase())
          " :to="{ name: 'shop-order-list' }" title="积分兑换礼品" value is-link>
            <div slot="icon" class="menu-icon">
              <img src="../../assets/img/user/icon6.png" alt />
            </div>
          </van-cell>
        </div>
      </div>

      <!-- 金融产品 -->
      <div class="jrong mt-30" v-if="
        channel &&
        ['bl', 'zn', 'tajk', 'ht', 'nyt'].includes(channel.toLowerCase()) &&
        goods &&
        goods.length > 0
      ">
        <div class="jrong-box">
          <div class="jrong-list flex-row flex-j-sb flex-wrap product-list">
            <router-link v-for="(n, i) in goods" class="jrong-list-item product mb-20"
              :to="{ name: 'shop-product', params: { id: n.id } }" :key="`goods-${i}`">
              <img :src="n.coverImg" />
              <div class="text fy">
                <b>{{ n.title }}</b>
              </div>
              <div class="price color-gray-dark fs-12 fy" style="text-decoration: line-through">
                市场价：{{ n.oldPriceStr }}元
              </div>
              <div class="ta-c">
                <van-button class="mt-5 bg-color-orange-shop fy" block size="small" type="warning">{{ n.scoreStr
                  }}积分</van-button>
              </div>
            </router-link>
          </div>
        </div>
      </div>

      <!-- 客服热线 -->
    </div>
    <div style="height: 50px"></div>
    <!-- 可用余额显示 -->
    <van-dialog v-model="showBalanceAvailabelQuestion" title="可用余额说明">
      <div class="tips-dialog fs-14">
        <span>1、可用余额：{{ numFormat(userInfo.custAccount.balance) }}元；</span><br />
        <span>2、特殊产品可用余额：{{
          numFormat(getSpecialProductTotalBalance)
        }}元；</span><br />
        <span>3、天安金交中心有最终解释权。</span><br />
      </div>
    </van-dialog>
    <!-- 体验金收益显示 -->
    <van-dialog v-model="showExperienceTips" title="体验金收益说明">
      <div class="tips-dialog fs-14">
        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;通过体验金参与指定体验资产所产生的收益，自发放日起6个月内有效，可用于在平台进行投资时抵扣，不可以提现或转让。</span>
      </div>
    </van-dialog>
    <!-- 总资产体验金收益显示 -->
    <van-dialog v-model="showProductExAmountTips" title="总资产说明">
      <div class="tips-dialog fs-14">
        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;包含平台发放的{{
          numFormat(userInfo.custAccount.productExAmount || 0)
        }}元体验金，通过体验金参与指定体验资产期限满后，天安金交中心收回体验金。
        </span>
      </div>
    </van-dialog>
    <!-- 预期收益体验金收益显示 -->
    <van-dialog v-model="showProductExReturnAmountTips" title="预期收益说明">
      <div class="tips-dialog fs-14">
        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;包含参与平台体验金活动获得的{{
          numFormat(userInfo.custAccount.productExReturnAmount || 0)
        }}元体验金收益，体验金收益可在有效期内在平台进行投资时抵扣，不可以提现或转让。</span>
      </div>
    </van-dialog>
  </div>
</template>

<script>
// import "swiper/dist/css/swiper.css"
import { swiper, swiperSlide } from "vue-awesome-swiper"
import {
  Row,
  Col,
  CellGroup,
  Icon,
  Cell,
  Button,
  Image,
  Sticky,
  Dialog,
  ImagePreview
} from "vant"
import { Swipe, SwipeItem } from "vant"
import { mapMutations, mapActions, mapGetters } from "vuex"
import storage from "@/utils/storage"
import * as GoodsApi from "@/api/goods"
import * as CustApi from "@/api/cust"
import * as PayApi from "@/api/pay"
import * as ProductApi from "@/api/product"
import * as SpecialPayApi from "@/api/special"

import centerImg1 from "../../assets/img/user/icon8.png"
import centerImg11 from "../../assets/img/common/shuang11-icon.jpg"
import centerImg2 from "../../assets/img/user/icon1.png"
import centerImg3 from "../../assets/img/user/icon9.png"
import centerImg4 from "../../assets/img/user/icon10.png"
import centerImg5 from "../../assets/img/user/icon11.png"
import centerImg6 from "../../assets/img/user/icon12.png"
import { noticed } from "../../api/lottery"
import session from "../../utils/session"
import { getCustomerList } from "../../api/user"

export default {
  name: "User",
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [CellGroup.name]: CellGroup,
    [Image.name]: Image,
    [Sticky.name]: Sticky,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [Button.name]: Button,
    [Dialog.Component.name]: Dialog.Component,
    [Dialog.name]: Dialog,
    [ImagePreview.Component.name]: ImagePreview.Component,
    swiper,
    swiperSlide
  },

  data() {
    return {
      client_bg: require("@/assets/img/user/hbg.png"),
      couponCount: 0,
      swiperOption: {
        slidesPerView: "auto",
        centeredSlides: true,
        spaceBetween: 20
      },
      goods: [],
      centerList: [],
      isShow: true,
      onShow: true,
      offShow: false,
      bankcard: {
        list: [],
        count: ""
      },
      sectionData: [],
      showBalanceAvailabelQuestion: false,
      showProductExAmountTips: false,
      showProductExReturnAmountTips: false,
      showExperienceTips: false,
      balances: []
    }
  },

  beforeMount() {
    this.getUserInfo().then((data) => {
      if (data.aprilOutingLottery) {
        this.showLotteryTips()
      }
      this.initCenterItem()
    })
    this.getSpecialBalance()

    // this.getGoodsList()

    let ref = this.$route.query.ref
    if (ref) {
      let channel = storage.get("app-channel") || "bl"
      this.setChannel(channel)
    }

    this.getBindCardList()
    this.getCouponCount()
  },

  methods: {
    initCenterItem() {
      this.centerList = [
        {
          id: "3",
          imgPath: centerImg3,
          title: "委托竞拍"
        },
        {
          id: "100",
          imgPath: centerImg3,
          title: "我的竞买"
        },
        {
          id: "4",
          imgPath: centerImg4,
          title: "我的订单"
        },
        {
          id: "2",
          imgPath: centerImg2,
          title: "我的理财"
        },
      ]

      if (this.userInfo.openMember) {
        //如果存在添加到集合首个位置
        this.centerList.unshift({
          id: this._isOnlyShowShuang11Icon() ? "111" : "1",
          imgPath: this._isOnlyShowShuang11Icon() ? centerImg11 : centerImg1,
          title: "积分商城"
        })
      }
      if (this.userInfo.entryTongRen) {
        this.centerList.push({
          id: "6",
          imgPath: centerImg6,
          title: "我的协议"
        })
      }
      ProductApi.getSectionIds()
        .then((data) => {
          this.sectionData = data
          if (this.sectionData && this.sectionData.length > 0) {
            const item = this.sectionData[0]
            this.centerList.splice(3, 0, {
              id: "5",
              imgPath: centerImg5,
              title: item.name
            })
          }
        })
        .catch((e) => {
          this.$toast(e.msg || e.message)
        })
    },
    showLotteryTips() {
      Dialog.alert({
        title: "温馨提示",
        message: "恭喜您获得抽奖机会，现在去抽奖吗？",
        confirmButtonText: "去抽奖",
        cancelButtonText: "关闭",
        messageAlign: "left",
        showCancelButton: true,
        theme: "round-button"
      })
        .then(() => {
          this.closeLotteryTips()
          this.$router.push({ name: "aprilLotter" })
        })
        .catch(() => {
          this.closeLotteryTips()
        })
    },
    closeLotteryTips() {
      noticed().then((data) => { })
      this.getUserInfo()
    },
    off() {
      this.isShow = false
      this.onShow = false
      this.offShow = true
    },
    on() {
      this.isShow = true
      this.offShow = false
      this.onShow = true
    },
    ...mapActions(["getUserInfo"]),
    getGoodsList() {
      // 产品列表
      GoodsApi.list({ pageNo: 1, pageSize: 4 })
        .then((data) => {
          this.goods = data.list
        })
        .catch((e) => {
          this.$toast(e.msg || e.message)
        })
    },
    getCouponCount() {
      PayApi.getRedPacketRecordNum()
        .then((data) => {
          this.couponCount = data.unUsedNum
        })
        .catch((e) => {
          console.info(e)
        })
    },
    getBindCardList() {
      CustApi.listBindCard()
        .then((data) => {
          this.bankcard.list = data || []
          if (data.length > 0) {
            this.bankcard.count = data.length + "张"
          } else {
            this.bankcard.count = "前往绑定"
          }
        })
        .catch((e) => {
          this.$toast(e.msg || e.message)
        })
    },
    toCardList() {
      session.setJson("cq", undefined)
      if (!this.userInfo.isAuthName) {
        this.$router.push({
          name: "realname",
          query: { redirect: "bindcard" }
        })
        return
      }
      if (this.bankcard.count < 1) {
        this.$router.push({ name: "bindcard" })
      } else {
        this.$router.push({ name: "cardlist" })
      }
    },
    to(path) {
      if (this.checkAccount() === true) {
        this.$router.push({ name: path })
      }
    },
    eysMoney(value) {
      return this.isShow ? value : "*".repeat(Math.max(6, value.length))
    },
    // 前往个人中心
    personalClick() {
      this.$router.push("/personalCenter")
    },
    // 前往会员中心
    clickMemberCenter() {
      this.$router.push("/memberCenter")
    },
    // 我的投资报告
    clickReportCenter() {
      localStorage.setItem(
        "ignoreCustKey",
        JSON.stringify({
          isBannerJump: false,
          ignore: 1
        })
      )
      this.$router.push({ name: "anniversarycelebration" })
    },

    // 前往设置
    settingClick() {
      this.$router.push("/options")
    },
    // 一键开户
    oneaccountClick() {
      this.$router.push("/oneaccount")
    },
    // 开户绑卡
    accountClick() {
      this.$router.push("/account")
    },
    // 我的邀请
    toMyInvite() {
      this.$router.push("/invite")
    },
    // 商城/理财/拍卖/订单
    onCenterItem(item) {
      switch (item.id) {
        case "1": // 积分商城
        case "111":
          sessionStorage.setItem("memberMallActive", 0)
          this.$router.push({ name: "integralMall" })
          break
        case "2": // 我的理财
          this.$router.push({ name: "investRecord" })
          break
        case "3":
          this.$router.push({ name: "myauction" })
          break
        case "4": // 我的订单
          this.$router.push({ name: "myorder" })
          break
        case "5": // 我的专享
          const item = this.sectionData[0]
          this.$router.push({
            name: "myexclusive",
            query: { sectionId: item.id }
          })
          break
        case "6": // 我的协议
          this.$router.push({ name: "myagreement" })
          break
        case "100":
          this.$router.push({ name: "myauction1" })
          break

        default:
          this.$toast("敬请期待！")
          break
      }
    },

    goWithdrawClick() {
      this.$router.push({ name: "myorder", params: { selectIndex: 2 } })
    },

    onRecharge() {
      //支付方式是否包括（充值 2 在线支付 3 余额支付 4 在线充值）
      if (!this.payType.payType.includes("4")) {
        // this.eftShow=true;// 线下充值
        this.$router.push({
          path: "/recharge_offline",
          query: { redirect: this.$route.fullPath }
        })
      } else {
        if (this.userInfo.isBindCard) {
          // this.$router.push({ name: "recharge_1" })
          this.$router.push({
            name: "recharge_offline",
            query: { redirect: this.$route.fullPath }
          })
        } else if (this.userInfo.isAuthName) {
          this.$router.push({ name: "recharge_2" })
        } else {
          this.$router.push({ name: "recharge_3" })
        }
      }
    },
    // toCardlist() {
    //   if(this.checkAccount() === true) {
    //     this.$router.push({name:'cardlist'});
    //   }
    // },
    checkAccount() {
      if (!this.userInfo.isAuthName) {
        this.$router.push({ name: "realname" })
      } else if (this.userInfo.isOpenAccount < 2) {
        this.$router.push({ name: "personalAccountOpening" })
      } else {
        return true
      }
    },

    onWithdrawDeposit() {
      if (this.checkAccount() === true) {
        if (this.userInfo.custAccount.balance > 0) {
          this.$router.push({ name: "withdraw" })
        } else {
          this.$toast("可用余额不足")
        }
      }
    },
    callPhone() { },
    ...mapMutations(["setToken", "setChannel"]),
    // 获取特殊产品目前可用余额
    getSpecialBalance() {
      SpecialPayApi.getSpecialBalance()
        .then((data) => {
          this.balances = data
        })
        .catch((e) => {
          this.$toast(e.msg || e.message)
        })
    },
    onPreview() {
      getCustomerList()
        .then((data) => {
          if (data.length > 0) {
            let imageList = data.map((item) => item.qyWechat)
            ImagePreview({
              images: imageList,
              closeable: true
            })
            if (this.isWechant()) {
              this.$toast("长按可保存图片")
            }
          }
        })
        .catch((e) => {
          console.log("error info == %O", e.msg)
        })
    }
  },

  // 我的银行卡
  watch: {
    "bankcard.list"(newVal, oldVal) {
      if (newVal && newVal.length) {
        this.bankcard.count = newVal.length + "张"
      } else {
        this.bankcard.count = ""
      }
    }
  },

  computed: {
    //根据渠道显示客服热线
    showCSH() {
      return ["bl", "tajk", "zn", "bn", "ht", "nyt"].includes(
        this.channel.toLowerCase()
      )
    },
    getActiveClass(isActive) {
      return (isActive) => {
        if (isActive) {
          return "options-list-item-active"
        }
      }
    },
    getSpecialProductTotalBalance() {
      let balance = 0
      this.balances.forEach((item) => {
        balance += item.balance
      })
      return balance
    },
    ...mapGetters(["os", "channel", "userInfo", "payType"])
  }
}
</script>

<style lang="less" scoped>
// 头部
.header {
  height: 80px;
  display: flex;
  justify-content: space-between;
  padding: 0 13px;
  background-color: #fff;

  .person {
    display: flex;
    align-items: center;

    .person-img {
      width: 50px;
      height: 50px;
    }

    .person-name {
      margin-left: 10px;

      .person-all {
        display: flex;

        .d1 {
          color: #333;
          font-size: 15px;
          font-weight: 700;
        }

        .memberGrade {
          // background-image: url({{userInfo.logo}});
          background-repeat: no-repeat;
          background-size: 100% 100%;
          width: 185 * 0.36px;
          height: 64 * 0.36px;
          margin-left: 5px;
          margin-top: -2px;
          align-items: center;

          .memberGrade-img {
            width: 100%;
            height: 100%;
          }
        }
      }

      .d2 {
        color: #999;
        font-size: 13px;
        margin-top: 5px;

        .van-icon {
          vertical-align: middle;
        }
      }
    }
  }

  .setting {
    width: 20px;
    overflow: hidden;

    .van-icon {
      margin-top: 15px;
      margin-left: 20px;
    }
  }
}

.content {
  margin: 0 13px;

  // 清除下边框
  ::v-deep .van-cell::after {
    border: none;
  }

  // 会员权益
  .memberCenter {
    background-image: url(../../assets/img/memberIntegral/mi_mine_bg.png);
    margin: 15px 0;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    border-radius: 5px;
    margin: 15px 0;
    padding: 10px 15px;

    .member-left {
      flex: 1;

      .member-zq {
        color: rgb(135, 71, 27);
        font-size: 16px;
        font-weight: 700;
        line-height: 30px;
      }

      .member-server {
        color: rgb(58, 55, 56);
        font-size: 14px;
        line-height: 30px;

        .member-server2 {
          color: rgb(231, 65, 41);
        }
      }
    }

    .member-right {
      // flex: 1;
      margin: 0;

      .right-bg {
        display: flex;
        // background-color: rgb(235, 201, 135);
        margin-right: -7px;
        justify-content: center;
        text-align: center;
        flex-direction: column;

        // border-top-left-radius: 25px;
        // border-bottom-left-radius: 25px;
        .member-qy {
          color: rgb(144, 90, 45);
          font-size: 16px;
          font-weight: 800;
        }
      }
    }
  }

  // 投资报告
  .reportCenter {
    position: relative;
    background-image: url(../../assets/img/my-redpack/anniversary/anniversary_report_bg.png);
    margin: 15px 0;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    border-radius: 5px;
    margin: 15px 0;
    padding: 0 15px;
    height: 80px;

    .bottom-bg {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      height: 100%;

      .title {
        color: rgb(135, 71, 27);
        font-size: 16px;
        font-weight: 700;
      }

      img {
        width: 110px;
        height: 30px;
      }
    }
  }

  // 总资产
  .assets-bg {
    margin-top: 10px;
    border-radius: 5px;
    // border: 1px solid #000;
    background-color: #fff;

    .assets {
      // display: flex;
      // align-items: center;
      padding: 20px 15px;
      padding-bottom: 0;

      .all {

        // flex: 1;
        .d1 {
          color: #666;
          font-size: 13px;
          display: flex;
          align-items: center;

          .van-icon {
            margin-left: 5px;
          }
        }

        .d2 {
          color: #333;
          font-size: 16px;
          font-weight: 700;
        }
      }

      .Obtain {
        // flex: 1;
        margin-top: 15px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .van-cell {
          padding: 0;
          border: none;

          .balance-title {
            color: #666;
            font-size: 14px;
          }

          .balance-value {
            color: #333;
            font-size: 16px;
            font-weight: 700;
          }
        }

        .d1 {

          // flex: 1;
          .sp1 {
            color: #666;
          }

          .sp2 {
            color: #333;
            font-weight: 700;
          }
        }

        .d2 {
          width: 1px;
          height: 20px;
          background-color: rgb(243, 243, 243);
        }

        .d3 {
          // flex: 1;
          // margin-top: 10px;
          text-align: right;

          .sp1 {
            color: #666;
          }

          .sp2 {
            color: #333;
            font-weight: 700;
          }
        }
      }

      .experience {
        margin-top: 15px;

        .sp1 {
          color: #666;
        }

        .sp2 {
          color: #333;
          font-weight: 700;
        }
      }
    }

    .underline {
      border: 0.5px solid rgb(243, 243, 243);
      margin: 15px 13px 0 13px;
    }

    .balance-list {
      margin: 0 15px;

      .van-cell {
        padding: 15px 0 0 0;
        border: none;

        .balance-title {
          color: #666;
          font-size: 13px;
        }

        .balance-value {
          color: #333;
          font-size: 16px;
          font-weight: 700;
        }
      }

      .balance-title {
        color: #666;
        font-size: 13px;
      }

      .balance-value {
        color: #333;
        font-size: 16px;
        font-weight: 700;
      }

      .chongzhi {
        width: 100%;
        padding: 15px 0;

        .b1 {
          width: 100%;
          height: 33px;
          color: #666;
          border: none;
          background-color: #f2f2f2;
        }

        .b2 {
          width: calc(50% - 7.5px);
          height: 33px;
          margin-left: 15px;
          color: #fff;
          border: none;
          background-color: #fc6524;
        }
      }
    }
  }

  // 商城/理财/拍卖/订单
  .center-bg {
    margin-top: 10px;
    border-radius: 5px;
    background-color: #fff;

    .center-list {
      white-space: nowrap;
      overflow-x: scroll;
    }

    .item {
      display: inline-block;
      text-align: center;
      padding: 20px 0;

      // width: calc(100% / 4);
      .item-img {
        width: 25px;
        height: 26px;
      }

      .shuang11-img {
        width: 32px;
        height: 33px;
      }

      .item-title {
        text-align: center;
        font-size: 12px;
        color: #666;
      }
    }
  }

  // 我的
  .my {
    margin-top: 10px;
    border-radius: 5px;
    background-color: #fff;

    .my-list {
      padding: 0 15px;

      .van-cell {
        border-bottom: 1px solid #efefef;

        .van-cell__title {
          color: #333;
          font-size: 14px;
          margin-left: -5px;
        }

        .van-cell__value {
          color: #666;
          font-size: 15px;
        }

        img {
          width: 20px;
          height: 20px;
        }
      }
    }
  }

  // 金融产品
  .jrong-box {
    border-radius: 8px;
    background-color: #ffffff;
  }

  .jrong {
    .jrong-list {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      padding: 27px 25px;

      .jrong-list-item {
        width: 130px;
        margin-bottom: 28px;

        img {
          width: 130px;
          height: 130px;
        }

        .text {
          b {
            height: 35px;
            font-size: 12px;
            font-weight: 700;
            color: #333333;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }
        }

        .price {
          color: #7b7a7a;
          font-size: 10px;
          margin-top: 10px;
          margin-bottom: 10px;
          text-decoration: line-through;
        }

        button {
          height: 26px;
          width: 130px;
          font-size: 12px;
          border-radius: 2px;
          border: none;
        }
      }
    }
  }

  // 客服热线
  .service-hotline {
    color: #999;
    margin: 35px 0;
    text-align: center;
  }
}

.page-container {
  background: #f1f5f8;
  padding: 0;
}

.top {
  padding: 20px 0;
  background: #1c1c1e;

  .swiper-slide {
    width: 290px;
    height: 170px;

    .card {
      overflow: hidden;
      width: 100%;
      height: 100%;
      border-radius: 10px;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: stretch;
      position: relative;

      .area1 {
        box-sizing: border-box;
        position: relative;
        height: 81px;
        padding: 15px 15px 5px 15px;

        .level-icon {
          width: 20px;
          position: relative;
          top: 2px;
        }

        .text {
          position: absolute;
          bottom: 10px;
          left: 0;
          width: 100%;
          text-align: center;
        }
      }

      .area2 {
        padding: 0 15px 5px 15px;
        position: relative;
        flex: 1;

        .cur-level {
          position: absolute;
          left: 0;
          width: 100%;
          top: 10px;
        }
      }

      &.level-1 {
        color: #9b7457;

        .title {
          color: #6f4829;
        }

        .area1 {
          background-image: radial-gradient(170px circle at 50% 0%,
              #f0dfcf,
              #c1a78e);
        }

        .area2 {
          background-image: linear-gradient(to top, #c1a78e, #c2a88f);
        }
      }

      &.level-2 {
        color: #8d8f9c;

        .title {
          color: #797979;
        }

        .area1 {
          background-image: radial-gradient(170px circle at 50% 0%,
              #dddfeb,
              #bbbfcb);
        }

        .area2 {
          background-image: linear-gradient(to top, #e0e3ec, #c4c7d3);
        }
      }

      &.level-3 {
        color: #a28242;

        .title {
          color: #81642a;
        }

        .area1 {
          background-image: radial-gradient(170px circle at 50% 0%,
              #f4e1b0,
              #baa166);
        }

        .area2 {
          background-image: linear-gradient(to top, #f4e1b0, #c1a76a);
        }
      }

      &.level-4 {
        color: #bb7847;

        .title {
          color: #6f270f;
        }

        .area1 {
          background-image: radial-gradient(170px circle at 50% 0%,
              #f9d9c1,
              #d09876);
        }

        .area2 {
          background-image: linear-gradient(to top, #f8d5bb, #d29a7a);
        }
      }

      &.level-5 {
        color: #6cbef9;

        .title {
          color: #0e4b8e;
        }

        .area1 {
          background-image: radial-gradient(170px circle at 50% 0%,
              #219fec,
              #0354bd);
        }

        .area2 {
          background-image: linear-gradient(to top, #219fec, #0956be);
        }
      }

      &.level-6 {
        color: #eed4c7;

        .title {
          color: #797979;
        }

        .area1 {
          background-image: radial-gradient(170px circle at 50% 0%,
              #525252,
              #0f0c1d);
        }

        .area2 {
          background-image: linear-gradient(to top, #494949, #110e1f);
        }
      }
    }
  }

  .tip {
    padding: 20px 20px 0 20px;
    color: #c1a76a;

    img {
      width: 16px;
      position: relative;
      top: 2px;
    }
  }
}

.user-assets {
  text-align: left;
  background: #fff;
  padding: 20px 0;

  .van-col {
    padding: 10px 20px;

    &:last-child {
      border-left: 1px solid @gray-light;
    }
  }
}

.privilege {
  .cur-level {
    justify-content: flex-start;
    align-items: stretch;

    .img {
      width: 50px;
      height: 50px;
      background: #f4e1b0;
      padding: 20px;
      border-radius: 50%;

      img {
        width: 100%;
      }
    }

    .van-button--default {
      border-color: #ac8b35;
      color: #ac8b35;
    }
  }

  .next-level-welfare {
    justify-content: space-between;
    align-content: stretch;
    text-align: center;
    padding: 10px 5px;

    .img {
      width: 60px;
      height: 60px;
      padding: 10px;
      border-radius: 50%;
      background: #f1f5f8;

      img {
        width: 100%;
      }
    }
  }
}

.calendar {
  padding-bottom: 10px;

  .title {
    font-size: 18px;
  }

  .van-cell {
    padding: 20px 0;

    &:not(:last-child)::after {
      left: 0;
    }

    .van-cell__left-icon {
      color: @gray;
      font-size: 32px;
      vertical-align: middle;
    }
  }

  .first-due {
    align-items: center;

    .van-cell__title {
      flex: none;
      width: 35%;

      .date {
        width: 40px;
        font-weight: bold;
        border: 1px solid @silvery;
        color: @silvery;
        border-radius: 5px;
        padding: 0 5px;
      }
    }
  }
}

.setting {
  padding: 0 20px;
}

.balance-control {
  background: #fff;

  .van-col {
    padding-top: 20px;
    padding-bottom: 20px;
    font-size: 20px;
  }

  .van-col:nth-of-type(1) {
    position: relative;

    &::after {
      content: "";
      position: absolute;
      right: 0;
      top: 20%;
      height: 60%;
      width: 1px;
      transform: translateX(0.5);
      background-color: #ccc;
      z-index: 1;
    }
  }

  .van-col:nth-of-type(2) {
    color: #df4845;
  }
}

.tips-dialog {
  padding: 10px;
  letter-spacing: 0px;
  line-height: 0.7rem;
}
</style>
